import React, {Component} from 'react';
import {Switch, withRouter} from "react-router-dom";
import {replace} from "react-router-redux";
import {connect} from "react-redux";
import {compose, bindActionCreators} from "redux";
import {withStyles} from "@material-ui/core";

import {messaging} from "../firebase";
import ListeningRoute from "../components/ListeningRoute";
import DeepImage from "../components/DeepImage";
import {verifyTokenSuccess} from "../redux/reducers/push";

import Collector, {PushCollector} from "./Collector";
import ConnectionCheck from './ConnectionCheck';
import Register from "../containers/Register";

import Welcome from "./Welcome";
import PushRequest from "./PushRequest";
import Success from "./Success";

const firebaseMessaging = messaging();

const styles = theme => ({
    containerRoot: {
        height: '100%',
        width: '100vw',
        overflow: 'hidden',
    },
    container: {
        height: '100%',
        width: '100%',
        maxWidth: 800,
        margin: 'auto',

        padding: theme.spacing.unit,

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    logo: {
        flex: 1,
        width: '100%',
        height: 'auto',
        maxHeight: 200,
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,

        transition: 'all 200ms linear',

        zIndex: 1,

        backgroundImage: 'url(' + require('../resources/logo/full.png') + ')',
        backgroundSize: 'contain',
        backgroundPosition: '0% 50%',
        backgroundRepeat: 'no-repeat',
    },
    overlay: {
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.6)',

        [theme.breakpoints.down(960)]: {
            background: 'rgba(0,0,0,0.6)',
        }
    },
});

class Router extends Component {
    componentDidMount() {
        !!firebaseMessaging && firebaseMessaging.onMessage((payload) => {
            console.log('Message received. ', payload);

            if (payload.data.click_action_pathname === '/verify/push') {
                this.props.verifyTokenSuccess();
            } else {
                console.log("SHOW MESSAGE");
            }
        });

        !!firebaseMessaging && firebaseMessaging.onTokenRefresh(async () => {
            try {
                const token = await firebaseMessaging.getToken();
                console.log('Token refreshed.', token);
            } catch(e) {
                console.error('Unable to retrieve refreshed token ', e);
            }
        });
    }

    render() {
        const {classes} = this.props;

        return (
            <DeepImage className={classes.container}
                       classes={{root: classes.containerRoot}}
                       Overlay={() => <div className={classes.overlay}/>}
                       backgroundImage={require('../resources/bg/background_blank.png')}
                       foregroundImage={require('../resources/bg/bin.png')}
            >
                <div className={classes.logo}/>
                <Switch>
                    <ListeningRoute path="/guest/s/:site" component={Collector} />
                    <ListeningRoute path="/collector" component={PushCollector} />

                    <ListeningRoute path="/landing" component={Welcome} />
                    <ListeningRoute path="/success" component={Success} />

                    <ListeningRoute path="/register/push/:data?" component={PushRequest} />
                    <ListeningRoute path="/error/push/:err" component={Register} />

                    <ListeningRoute path="/register/sns" component={Register}/>
                    <ListeningRoute path="/register/sms/verify" component={Register}/>


                    <ListeningRoute path="/error/:type/:err" component={Register}/>

                    {/*<ListeningRoute path="/register/:method?/:data?" component={Register}/>*/}

                    <ListeningRoute path="/" exact component={ConnectionCheck}/>
                </Switch>
            </DeepImage>
        );
    }
}

Router.propTypes = {};
Router.defaultProps = {};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = dispatch => bindActionCreators({
    replace,
    verifyTokenSuccess
}, dispatch);

export default compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(Router);


// WEBPACK FOOTER //
// ./src/containers/Router.js